import { render, staticRenderFns } from "./Discuss.vue?vue&type=template&id=3c95a57c&"
import script from "./Discuss.vue?vue&type=script&lang=js&"
export * from "./Discuss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports